const constant = {
  primaryColor: "#333",
  borderColor: "#333",
  blackColor: "#000",
};

export default constant;
